import { Swords, Trophy, Zap } from "lucide-react";
import { useAudio } from "../Stores/useAudio";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useDispatch } from "react-redux";

export const BadgeSection = () => {
  const { setAudioURL } = useAudio();
  const state = useSelector((state) => state.reducer);
  const [isExpand, setIsExpand] = useState(false);
  const MAX_COLLAPSED_ITEMS = 0;
  const dispatch = useDispatch();

  return (
    <div
      className={`bg-white shadow-sm p-6 border rounded-lg transition-all ease-in-out ${
        isExpand ? "max-h-[1000px]" : "max-h-[100px]"
      }`}
    >
      <div className="flex items-center mb-4">
        <h2 className="mb-4 font-bold text-xl cursor-pointer" onClick={(e) => setIsExpand(!isExpand)}>Your Badges</h2>
      </div>
      <div className="justify-center items-center gap-4 grid grid-cols-4">
        {state.badgeData
          .slice(0, isExpand ? state.badgeData.length : MAX_COLLAPSED_ITEMS)
          .map((item, index) => {
            return item === "Welcome Aboard" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge0.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by logging in — welcome aboard!" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Trophy className="w-5 h-5 text-amber-500" />
                <span className="font-medium">Welcome Aboard</span>
              </button>
            ) : item === "First claim added" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge1.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by creating first claim!" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Swords className="w-5 h-5 text-gray-500" />
                <span className="font-medium">First Steps</span>
              </button>
            ) : item === "5 claims added" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge2.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by creating 5 claims" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Getting the Hang of It</span>
              </button>
            ) : item === "Decline Crusher" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge6.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Overturning a denied claim" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Decline Crusher</span>
              </button>
            ) : item === "Early Bird" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge7.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Closing a claim in ≤50 days" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Early Bird</span>
              </button>
            ) : item === "Settlement King" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge13.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Securing a $50K+ settlement" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Settlement King</span>
              </button>
            ) : item === "Power Closer" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge12.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Closing 25 claims" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Power Closer</span>
              </button>
            ) : item === "Case Juggler" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge14.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by 20+ active claims" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Case Juggler</span>
              </button>
            ) : item === "100 Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge15.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 100 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">100 Club</span>
              </button>
            ) : item === "500 Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge16.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 500 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">500 Club</span>
              </button>
            ) : item === "1K Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge17.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 1000 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">1K Club</span>
              </button>
            ) : item === "2.5K Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge18.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 2500 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">2.5K Club</span>
              </button>
            ) : item === "5K Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge19.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 5000 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">5K Club</span>
              </button>
            ) : item === "10K Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge20.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 10,000 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">10K Club</span>
              </button>
            ) : item === "25K Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge21.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 25,000 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">25K Club</span>
              </button>
            ) : item === "50K Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge22.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 50,000 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">50K Club</span>
              </button>
            ) : item === "75K Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge23.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 75,000 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">75K Club</span>
              </button>
            ) : item === "100K Club" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge24.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 100,000 points" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">100K Club</span>
              </button>
            ) : item === "Superstar Agent" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge29.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Earning $1M in settlements" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Superstar Agent</span>
              </button>
            ) : item === "Sending the First Threat" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge3.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by sending First AFCA threat" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Sending the First Threat</span>
              </button>
            ) : item === "AFCA Warrior" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge26.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Sent 10 AFCA threats" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">AFCA Warrior</span>
              </button> 
            ) : item === "AFCA General" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge27.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Sent 50 AFCA threats" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">AFCA General</span>
              </button>
            ) : item === "Client Champion" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge9.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 5 five-star Google reviews" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Client Champion</span>
              </button>
            ) : item === "Scope King" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge5.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by first successful scope expansion" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Scope King</span>
              </button>
            ) : item === "Appeal Winner" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge28.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Win 3 AFCA appeals" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Appeal Winner</span>
              </button>
            ) : item === "Referral Master" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge11.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Completing 3 successful referrals" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Referral Master</span>
              </button>
            ) : item === "Early Learner" ? (
              <button
                key={index}
                onClick={() => {setAudioURL(["/sounds/badge/badge4.mp3"]); dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by clicking on the Points Guide" });}}
                className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full"
              >
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="font-medium">Early Learner</span>
              </button>
            ) : null;
          })}
      </div>
    </div>
  );
};
